const documentManager = {
    documentList: [],
    loadingDocuments: true
};

export default documentManager;
